module.exports = __webpack_public_path__ + "static/media/Skydiver.7329edfb.jpg";